export default __webpack_public_path__ + "static/media/hello.a44361b4.jpg";